import { Fan } from "@/services/bedrock";
import { FanCreationSchemaType } from "@/components/Forms/FanCreationForm";

export function toOptionalFanId(id: string | number | null | undefined): number | undefined {
  if (id == null || id === -1 || id === "") return undefined;
  const numericId = Number(id);
  return Number.isFinite(numericId) ? numericId : undefined;
}

/**
 * Utility to extract default form values from a Fan record for use in FanCreationForm.
 */
export function getFanFormDefaultValues(
  fan: Partial<Fan> | null | undefined,
  playerId?: number,
  fallbackName?: string
): Partial<FanCreationSchemaType> {
  if (!fan) {
    return {
      displayName: fallbackName || "",
      email: "",
      phoneNumber: "",
      fanType: "customer",
      notes: "",
      playerId: playerId ?? null,
      stateCode: "",
      defaultLanguage: "en",
      internalIdentifier: "",
    };
  }

  return {
    displayName: fan.displayName || fallbackName || "",
    email: fan.email || "",
    phoneNumber: fan.phoneNumber || "",
    fanType: fan.fanType === "partner" ? "partner" : "customer",
    notes: fan.notes || "",
    playerId: fan.player?.id || null,
    stateCode: fan.stateCode || "",
    defaultLanguage: fan.defaultLanguage || "",
    internalIdentifier: fan.internalIdentifier || "",
  };
}
